import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import * as deepfilter from 'deep-filter';

// Import navigation elements
import * as _ from 'underscore';
import { navigation } from './../../../../_nav';

@Component({
    selector: 'app-sidebar-menu',
    template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navigation">
          <li *ngIf="!isEmpty(navitem) && isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="!isEmpty(navitem) && isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isEmpty(navitem) && !isDivider(navitem)&&!isTitle(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`
})
export class AppSidebarMenuComponent implements OnInit{

    public navigation = navigation;

    public isDivider(item) {
        return item.divider ? true : false
    }

    public isTitle(item) {
        return item.title ? true : false
    }

    public isEmpty(item) {
        return _.isEmpty(item);
    }

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
        if(!this.auth.isAdmin()){
            console.log(this.auth.getPortalDefault());
            this.navigation = deepfilter(this.navigation, (value, prop, subject) => {
                return (!subject.hasOwnProperty('profiles') || ( subject.hasOwnProperty('profiles') && _.intersection(subject.profiles, this.auth.getProfiles()).length > 0));
            });
        }
    }

}

import { Router } from '@angular/router';
import {AuthService} from '../../../service/auth.service';

@Component({
    selector: 'app-sidebar-nav-item',
    template: `
        <div *ngIf="!isEmpty()" >
            <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
              <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
            </li>
            <ng-template #dropdown>
              <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
                  [class.open]="isActive()"
                  routerLinkActive="open"
                  appNavDropdown>
                <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
              </li>
            </ng-template>
        </div>
    `
})
export class AppSidebarNavItemComponent {
    @Input() item: any;

    public hasClass() {
        return this.item.class ? true : false
    }

    public isDropdown() {
        return this.item.children ? true : false
    }

    public thisUrl() {
        // està mal  retorna siempre true porque coge solo el nivel de dropdown que tienen url #
        //habria que bajar de nivel??
        return this.item.url
    }

    public isActive() {

        return this.router.isActive(this.thisUrl(), true)//at start -->false=open/true=close
    }

    public isEmpty(){
        return _.isEmpty(this.item);
    }

    constructor( private router: Router )  { }

}

@Component({
    selector: 'app-sidebar-nav-link',
    template: `
    <a *ngIf="!isExternalLink(); else external"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      [routerLinkActive]="isActive()"
      [routerLink]="[link.url]">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        <span class="label-link">{{ link.name }}</span>
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ng-template #external>
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
  `
})
export class AppSidebarNavLinkComponent {
    @Input() link: any;

    public hasVariant() {
        return this.link.variant ? true : false
    }

    public isBadge() {
        return this.link.badge ? true : false
    }

    public isExternalLink() {
        return this.link.url.substring(0, 4) === 'http' ? true : false
    }

    public isIcon() {
        return this.link.icon ? true : false
    }

    public isActive(){
        //todo encontrar como poner class active cuando entra en sub tabs ejemplo -portal-services
        return 'active';
    }

    constructor(private router: Router) { }
}

@Component({
    selector: 'app-sidebar-nav-dropdown',
    template: `
    <a  *ngIf="!isLink()" class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        <span [ngClass]="isParent()?'parent':'label-no-link'">{{ link.name }}</span>
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>

    <a  *ngIf="isLink()" class="nav-link nav-dropdown-toggle" appNavDropdownToggle  [routerLinkActive]="'active'"
        [routerLink]="[link.url]">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        <span [ngClass]="isParent()?'parent label-link':'label-no-link'">{{ link.name }}</span>
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>

    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
    @Input() link: any;

    public isBadge() {
        return this.link.badge ? true : false
    }

    public isIcon() {
        return this.link.icon ? true : false
    }

    public isParent(){
        return this.link.parent?true:false;
    }
    public isLink(){
        return (this.link.url != '#')?true:false;
    }




    constructor() { }

}

@Component({
    selector: 'app-sidebar-nav-title',
    template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
    @Input() title: any;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        const nativeElement: HTMLElement = this.el.nativeElement;
        const li = this.renderer.createElement('li');
        const name = this.renderer.createText(this.title.name);

        this.renderer.addClass(li, 'nav-title');

        if ( this.title.class ) {
            const classes = this.title.class;
            this.renderer.addClass(li, classes);
        }

        if ( this.title.wrapper ) {
            const wrapper = this.renderer.createElement(this.title.wrapper.element);

            this.renderer.appendChild(wrapper, name);
            this.renderer.appendChild(li, wrapper);
        } else {
            this.renderer.appendChild(li, name);
        }
        this.renderer.appendChild(nativeElement, li)
    }
}

export const APP_SIDEBAR_NAV = [
    AppSidebarMenuComponent,
    AppSidebarNavDropdownComponent,
    AppSidebarNavItemComponent,
    AppSidebarNavLinkComponent,
    AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/layout/sidebar-menu/sidebar-menu.component.ts